import React from 'react';
import ProjectDetails from './ProjectDetail/ProjectDetails';

function index() {
    return (
        <>
            <ProjectDetails />
        </>
    )
}

export default index